<template>
  <div>
    <v-divider class="mt-6 mb-4"></v-divider>
    <v-row class="mb-2 px-3">
      <v-col  cols="12" md="10" lg="10">
        <v-file-input
          v-if="!isOriginal"
          v-model="attachments"
          color="primary accent-4"
          counter
          label="Upload Attachments"
          multiple
          placeholder="Select your files"
          prepend-icon="mdi-paperclip"
          accept="image/*,.pdf"
          outlined
          dense
          hide-details
          :show-size="1000"
          @change="addFile()"
        >
          <template v-slot:selection="{ index, text }">
            <v-chip
              v-if="index < 2"
              color="primary accent-4"
              dark
              label
              small
              append-icon="mdi-close"
            >
              {{ text }}
            </v-chip>
            <span
              v-else-if="index === 2"
              class="text-overline grey--text text--darken-3 mx-2"
            >
              +{{ fileList.length - 2 }} File(s)
            </span>
          </template>
        </v-file-input>
        <v-select
          v-else
          :items="attachmentOptions"
          label="Select File"
          outlined
          placeholder="Select File"
          v-model="selectedFile"
          dense
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" lg="2">
        <v-btn
          class="secondary mt-1"
          @click="!isOriginal ? previewAddFiles() : previewViewOrder()"
          :disabled="!isOriginal ? attachments.length <= 0 : !selectedFile"
          style="width: 100%; margin: 0 auto"
          >Preview</v-btn
        >
      </v-col>
    </v-row>

    <v-row class="px-10 mb-8" v-if="fileList.length > 0">
      <v-data-table :headers="headers" :items="fileList" hide-default-footer>
        <template v-slot:body="{ items }">
          <tr v-for="(item, index) in items" :key="item.name">
            <td class="px-3 py-2">{{ item.name }}</td>
            <td class="px-3 py-2">{{ item.size }}</td>
            <td class="px-3 py-2">
              <v-icon medium color="red" @click="deleteFile(index)"
                >mdi-close-circle</v-icon
              >
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-row>
    
    <v-dialog v-model="previewAddFilesDiag" width="1080" persistent>
      <v-card class="pa-4">
        <v-card-text
          style="border: 1px solid #ccc; width: 98%; margin: 0 auto"
          class="pa-4"
        >
          <div v-if="pictureUrl.length">
            <div v-for="(item, index) in pictureUrl" :key="index">
              <h3 class="center">File name: {{ item.name }}</h3>
              <v-img
                :src="item.src"
                style="margin: 0 auto"
                class="mb-4"
              ></v-img>
            </div>
          </div>
          <div v-if="initialDocFile.length" class="mt-4">
            <div v-for="(item, index) in initialDocFile" :key="index">
              <h3 class="center">File name: {{ item.name }}</h3>
              <iframe
                ref="pdfView"
                style="width: 100%; height: 500px"
                frameborder="0"
                scrolling="no"
                :src="item.src"
              >
                <p>It appears your web browser doesn't support iframes.</p>
              </iframe>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <div class="fixed-bar rtl primary py-4">
        <v-btn @click="close()" class="mr-4">Close</v-btn>
      </div>
    </v-dialog>

    <v-dialog v-model="previewViewOrderDiag" :width="isPdf ? '1600' : '1080'" persistent>
      <v-card class="pa-4">
        <v-card-text
          style="border: 1px solid #ccc; width: 98%; height:100%; margin: 0 auto"
          class="pa-4"
        >
          <div v-if="!isPdf">
            <h3 class="center">File name: {{ selectedFile }}</h3>
            <v-btn
              class="secondary mt-1"
              @click="downloadImage"
              style="width: 100%; margin: 0 auto"
              >download</v-btn>
            <v-img
              :src="initialDocFile"
              style="margin: 0 auto"
              class="mb-4"
            ></v-img>
          </div>
          <div v-else class="mt-4">
            <h3 class="center">File name: {{ selectedFile }}</h3>
            <iframe
              ref="pdfView"
              style="width: 100%;"
              scrolling="no"
              height="650"
              :src="initialDocFile"
            >
              <p>It appears your web browser doesn't support iframes.</p>
            </iframe>
          </div>
        </v-card-text>
      </v-card>
      <div class="fixed-bar rtl primary py-4">
        <v-btn @click="close()" class="mr-4">Close</v-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "NbnOrderAttachments",
  props: {
    custAuthRef: { type: String },
  },
  data: () => ({
    fileList: [],
    attachments: [],
    previewAddFilesDiag: false,
    previewViewOrderDiag: false,
    selectedFile: '',
    attachmentOptions: [],
    initialDocFile: [],
    pictureUrl: [],
    headers: [
      { text: "File Name", value: "name" },
      { text: "File Size", value: "size" },
      { text: "Action", value: "action" },
    ],
    isPdf: false
  }),
  methods: {
    deleteFile(index) {
      let vm = this;
      vm.fileList.splice(index, 1);
      vm.attachments.splice(index, 1);
    },
    addFile() {
      let vm = this;
      vm.attachments.forEach((x) => {
        vm.fileList.push({
          name: x.name,
          size: `${(x.size / 1000).toFixed(2)}KB`,
          action: null,
        });
      });
    },
    async downloadImage() {
      let vm = this
      const image = await fetch(vm.initialDocFile)
      const imageBlog = await image.blob()
      const imageURL = URL.createObjectURL(imageBlog)
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = imageURL;
      link.download = vm.selectedFile;
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(imageURL);
    },
    previewViewOrder() {
      const vm = this;
      vm.isPdf = vm.selectedFile.includes('pdf');
      vm.initialDocFile = `${
        process.env.API
      }/api/OptusNBN/PreviewFile/${vm.custAuthRef}/${vm.selectedFile}`;
      vm.previewViewOrderDiag = true;
    },
    loadPDF(type, file) {
      const vm = this;
    var reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onloadend = function () {
      var base64 = btoa(reader.result);
     
        vm.initialDocFile = [{
          name: file.name,
          src: `data:${type};base64,` + base64,
        }];
    };
    },
    loadImage(file) {
      const vm = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        var binaryString = new Uint8Array(e.target.result);
        var url = URL.createObjectURL(new Blob([binaryString]));
        vm.pictureUrl.push({
          name: file.name,
          src: url,
        });
      };
      reader.readAsArrayBuffer(file);
    },
    previewAddFiles() {
      const vm = this;
      vm.previewAddFilesDiag = true;
      if (vm.attachments) {
        vm.attachments.forEach((attachment) => {
          if (attachment.type === "application/pdf") {
            vm.loadPDF(attachment.type, attachment);
          }
          if (attachment.type === "image/jpeg") {
            vm.loadImage(attachment);
          }
        });
      }
    },
    close() {
      let vm = this;
      vm.previewAddFilesDiag = false;
      vm.previewViewOrderDiag = false;
      vm.initialDocFile = {};
      vm.pictureUrl = [];
      vm.selectedFile = '';
      vm.fileList = [];
    }
  },
  watch: {
    orderAttachments(){
        let vm = this;
        vm.attachmentOptions = vm.orderAttachments;
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-bar {
  width: 100%;
  position: sticky;
  bottom: -1px;
}
.rtl {
  direction: rtl;
}
.center {
  text-align: center;
  margin: 0 auto 10px;
}
</style>
